<template>
    <div>
        <!-- <v-window-item :value="0">
                <v-list two-line subheader :style="'height: 50vh; overflow: auto'">
                    <v-subheader class="pb-2">
                        Sélectionnez les comptes bancaires à fusionner
                    </v-subheader>
                        <v-snackbar
                            v-if="getMergeMessage()"
                            :value="getMergeMessage()"
                            timeout="-1"
                            absolute
                        >
                            {{ getMergeMessage() }}
                        </v-snackbar>
                        <v-list-item
                            v-for="(bankAccount,i) in bankAccounts"
                            :key="i+bankAccount.id"
                            class="oss-list-item mb-2"
                            :disabled="isMergeDisabled(bankAccount)"
                        >
                            <v-tooltip bottom :disabled="!isMergeDisabled(bankAccount)">
                                <template v-slot:activator="{ on }">
                                    <template class="py-0" v-on="on">
                                        <v-list-item-title class="d-flex align-center justify-center" style="text-overflow: ellipsis; max-width: 600px">
                                            {{ bankAccount.name }}
                                        </v-list-item-title>
                                    </template>
                                    <template v-slot:append>
                                        <v-checkbox
                                            :disabled="isMergeDisabled(bankAccount)"
                                            v-model="bankAccountsToMerge"
                                            :value="bankAccount"
                                            color="primary"
                                            class="pa-0 ma-0"
                                        ></v-checkbox>
                                    </template>
                                </template>
                                <span v-if="isMergeDisabled(bankAccount)">{{ getMergeMessage() }}</span>
                            </v-tooltip>
                        </v-list-item>
                </v-list>
            </v-window-item> -->
        <v-list subheader :style="'height: 50vh; overflow: auto'" lines="two">
            <v-list-subheader> Sélectionnez le compte bancaire à conserver </v-list-subheader>
            <v-text-field-filled
                label="Nom du nouveau compte en banque"
                v-model="toKeepBankAccount.name"
                hide-details
                class="mb-2"
                outlined
                density="compact"
            />
            <v-row no-gutters class="mb-2">
                <v-col>
                    <oss-date-picker-filled
                        v-model="toKeepBankAccount.startAuthorizedDate"
                        :textFieldReadOnly="true"
                        label="Date de clôture des flux bancaires"
                        :mandatory="false"
                        :clearable="true"
                    >
                    </oss-date-picker-filled>
                </v-col>
            </v-row>
            <div class="d-flex align-center mb-2">
                <b>IBAN : </b
                >{{
                    " " + toKeepIban && (toKeepIban !== null || undefined)
                        ? toKeepIban
                        : "Non renseigné"
                }}
            </div>
            <div class="d-flex align-center mb-2">
                <b>BIC : </b
                >{{
                    " " +
                    (toKeepBic &&
                        (toKeepBic !== null || toKeepBic !== undefined || toKeepBic !== ""))
                        ? toKeepBic
                        : "Non renseigné"
                }}
            </div>
            <div class="d-flex align-center mb-2">
                <b>Identifiant créancier sepa : </b
                >{{
                    " " +
                    (toKeepICS && toKeepICS !== null && toKeepICS && undefined && toKeepICS !== "")
                        ? toKeepICS
                        : "Non renseigné"
                }}
            </div>
            <!-- <v-text-field
                label="IBAN du nouveau compte en banque"
                v-model="toKeepBankAccount.iban"
                hide-details
                class="oss- mb-2"
                :readonly="true"
                outlined
                dense
            ></v-text-field>
            <v-text-field
                label="BIC du nouveau compte en banque"
                v-model="toKeepBankAccount.bic"
                hide-details
                class="oss- mb-2"
                :readonly="true"
                outlined
                dense
            ></v-text-field> -->
            <v-list-item
                v-for="(bankAccount, i) in toMergeBankAccounts"
                :key="i + bankAccount.id"
                class="mb-2"
                @click="selectToKeepBankAccount(bankAccount)"
                :disabled="isBudgetInsightAccount(bankAccount)"
                density="compact"
                rounded="xl"
                border
                lines="two"
            >
                <v-list-item-title style="text-overflow: ellipsis; max-width: 600px">
                    <b>{{ bankAccount.name }}</b>
                </v-list-item-title>
                <template v-slot:append class="my-0">
                    <v-btn-icon
                        :disabled="isBudgetInsightAccount(bankAccount)"
                        color="primary"
                        :icon="
                            bankAccount.id === toKeepBankAccount.id
                                ? '$radio_button_checked'
                                : '$radio_button_unchecked'
                        "
                    >
                    </v-btn-icon>
                </template>
            </v-list-item>
        </v-list>
    </div>
</template>

<script lang="ts">
import BANK_ACCOUNTS_MERGE from "../../graphql/bank/BankAccountsMerge.gql";
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["bankAccounts-merged"],
})
export class MergeBankAccounts extends Vue {
    @Prop({ default: [] }) bankAccountsToMerge: Array<any>;
    @Prop({ default: null }) companyId: string;
    @Prop({ default: null }) actions: any;

    // bankAccountsToMerge = []
    toKeepBankAccount: any = {};
    toMergeBankAccounts = [];
    toKeepIban = "";
    toKeepBic = "";
    toKeepICS = "";

    selectToKeepBankAccount(bankAccount) {
        this.toKeepBankAccount = bankAccount;

        if (!this.toKeepBankAccount.iban) {
            this.toKeepBankAccount.iban = this.toKeepIban;
        }

        if (!this.toKeepBankAccount.bic) {
            this.toKeepBankAccount.bic = this.toKeepBic;
        }

        if (!this.toKeepBankAccount.creditorIdentifier) {
            this.toKeepBankAccount.creditorIdentifier = this.toKeepICS;
        }
    }

    beforeMount() {
        this.toMergeBankAccounts.push(...JSON.parse(JSON.stringify(this.bankAccountsToMerge)));
        this.initializeToKeepBankAccount();
        this.setActions();
    }

    // @Watch("toKeepBankAccount")
    // onToKeepBankAccountChange() {
    //     if (this.toKeepBankAccount?.id) {
    //         this.toMergeBankAccounts = this.toMergeBankAccounts.filter((bankAccount) => bankAccount.id !== this.toKeepBankAccount.id)
    //     } else {
    //         this.toMergeBankAccounts = []
    //     }
    // }

    async bankAccountsMerge() {
        if (this.companyId && this.toKeepBankAccount?.id && this.toMergeBankAccounts?.length) {
            const toKeepBankAccountIndex = this.toMergeBankAccounts.findIndex(
                (bankAccount) => bankAccount.id === this.toKeepBankAccount.id,
            );

            if (toKeepBankAccountIndex !== -1) {
                this.toMergeBankAccounts.splice(toKeepBankAccountIndex, 1);
            }

            try {
                const mergedBankAccounts = await this.$apollo.mutate({
                    mutation: BANK_ACCOUNTS_MERGE,
                    variables: {
                        toKeepBankAccountId: this.toKeepBankAccount.id,
                        toMergeBankAccountIds: this.toMergeBankAccounts.map(
                            (bankAccount) => bankAccount.id,
                        ),
                        companyId: this.companyId,
                        toKeepBankAccount: this.toKeepBankAccount,
                    },
                });
                debugger;
                if (mergedBankAccounts?.data?.bankAccountsMerge) {
                    this.$emit("bankAccounts-merged", mergedBankAccounts.data.bankAccountsMerge);
                }
            } catch (e) {
                console.error(e);
            }
        }
    }

    // @Watch("toMergeBankAccounts", {deep: true})
    // isMergeDisabled(bankAccount) {

    //     if (this.toMergeBankAccounts.find(account => account.id === bankAccount.id)) {
    //         return false;
    //     }

    //     if (this.toMergeBankAccounts.length > 1) {
    //         return true;
    //     }

    //     if (this.hasBudgetInsightIdSelected() && bankAccount.budgetInsightId) {
    //         return true;
    //     }

    //     if (bankAccount.iban === '') {
    //         return false;
    //     }

    //     if (bankAccount.iban && this.toMergeBankAccounts.some(account => account.iban && account.iban !== bankAccount.iban)) {
    //         return true;
    //     }
    //     // Sinon, permettre la sélection
    //     return false;
    // }

    // hasBudgetInsightIdSelected() {
    //     // Vérifie si un compte avec budgetInsightId est déjà sélectionné
    //     return this.toMergeBankAccounts.some(account => account.budgetInsightId);
    // }

    isBudgetInsightAccount(bankAccount) {
        if (this.toKeepBankAccount?.id === bankAccount.id) {
            return false;
        }
        if (bankAccount.budgetInsightId) {
            return false;
        }

        if (
            !bankAccount.budgetInsightId &&
            !this.toMergeBankAccounts.some((account) => account.budgetInsightId)
        ) {
            return false;
        }

        return true;
    }

    // @Watch("toKeepBankAccount", {deep: true})
    initializeToKeepBankAccount() {
        const accountWithBudgetInsight = this.toMergeBankAccounts.find(
            (account) => account.budgetInsightId,
        );

        const accountWithIbanAndBic = this.toMergeBankAccounts.find(
            (account) => account.iban && account.bic,
        );

        if (accountWithBudgetInsight) {
            this.toKeepBankAccount = accountWithBudgetInsight;

            if (accountWithBudgetInsight.iban && accountWithBudgetInsight.iban !== "") {
                this.toKeepIban = accountWithBudgetInsight.iban;
            }

            if (accountWithBudgetInsight.bic && accountWithBudgetInsight.bic !== "") {
                this.toKeepBic = accountWithBudgetInsight.bic;
            }

            if (
                accountWithBudgetInsight.creditorIdentifier &&
                accountWithBudgetInsight.creditorIdentifier !== ""
            ) {
                this.toKeepICS = accountWithBudgetInsight.creditorIdentifier;
            }
        } else if (accountWithIbanAndBic) {
            this.toKeepBankAccount = accountWithIbanAndBic;

            if (accountWithIbanAndBic.iban && accountWithIbanAndBic.iban !== "") {
                this.toKeepIban = accountWithIbanAndBic.iban;
            }

            if (accountWithIbanAndBic.bic && accountWithIbanAndBic.bic !== "") {
                this.toKeepBic = accountWithIbanAndBic.bic;
            }

            if (
                accountWithIbanAndBic.creditorIdentifier &&
                accountWithIbanAndBic.creditorIdentifier !== ""
            ) {
                this.toKeepICS = accountWithIbanAndBic.creditorIdentifier;
            }
        } else {
            this.toKeepBankAccount = this.toMergeBankAccounts[0];
            this.toKeepIban = this.toMergeBankAccounts[0].iban;
            this.toKeepBic = this.toMergeBankAccounts[0].bic;
            this.toKeepICS = this.toMergeBankAccounts[0].creditorIdentifier;
        }

        if (!this.toKeepBankAccount.iban && !this.toKeepBankAccount.bic) {
            const otherAccount = this.toMergeBankAccounts.find(
                (account) => account !== this.toKeepBankAccount,
            );
            if (otherAccount?.iban) {
                this.toKeepIban = otherAccount.iban;
            }

            if (otherAccount?.bic) {
                this.toKeepBic = otherAccount.bic;
            }

            if (otherAccount?.creditorIdentifier) {
                this.toKeepICS = otherAccount.creditorIdentifier;
            }
        }

        if (this.toKeepIban) {
            this.toKeepBankAccount.iban = this.toKeepIban;
        }

        if (this.toKeepBic) {
            this.toKeepBankAccount.bic = this.toKeepBic;
        }

        if (this.toKeepICS) {
            this.toKeepBankAccount.creditorIdentifier = this.toKeepICS;
        }
    }

    getMergeMessage() {
        // if (!this.ibansAreCompatible) {
        //     return "Les IBANs ne sont pas compatibles"
        // }
        // if (this.hasBudgetInsightIdSelected()) {
        //     return "Vous ne pouvez pas fusionner plusieurs comptes Budget Insight"
        // }
        // if (this.bankAccountsToMerge.length > 1) {
        //     return "Nombres de comptes bancaires sélectionnés maximum atteint"
        // }
    }

    setActions() {
        if (this.actions?.action) {
            this.actions.action.function = this.bankAccountsMerge;
            this.actions.action.disabled = () => {
                return !this.toKeepBankAccount?.id;
            };
            this.actions.action.hideValid = false;
            this.actions.action.title = "Valider la fusion";
        }
    }

    getOrigin(account) {
        if (account.budgetInsightId) {
            return "Import automatique";
        }
        return "Import manuel";
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }
}

export default toNative(MergeBankAccounts);
</script>
